<app-breadcrumb
  [title]="'Crear rutas'"
  [items]="['Extractos', 'Rutas']"
  [active_item]="'Crear rutas'"
></app-breadcrumb>


<div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-verification-check me-2"></i>
      <h5 class="mb-0">Crear ruta</h5>
    </div>
  
    <div class="card-body">
      <form ngNativeValidate>
        <div class="row g-3">
          <div class="col-md-3 mb-3">
            <label class="form-label" for="fechaInicialRCC">Origen *:</label>
            <ng-select [items]="Origen" placeholder="Seleccione el origen"
            required="" class="js-example-placeholder-multiple" [(ngModel)]="origen"></ng-select>
          </div>
  
          <div class="col-md-3 mb-3">
            <label class="form-label" for="fechaFinalRCC">Destino *:</label>
            <ng-select [items]="Destino" placeholder="Seleccione un destino"
            required="" class="js-example-placeholder-multiple" [(ngModel)]="destino"></ng-select>
          </div>
  
          <div class="col-md-3 mb-3">
            <label class="form-label" for="fechaFinalRCC">Nombre de la ruta *:</label>
            <input
                    class="form-control"
                    id="validationCustom01"
                    type="text"
                    placeholder="Nombre de la ruta"
                    required=""
                    onlyAlphabets
                  />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label" for="fechaFinalRCC">Descripción *:</label>
            <input
                    class="form-control"
                    id="validationCustom01"
                    type="text"
                    placeholder=""
                    required=""
                    onlyAlphabets
                  />
          </div>
  
            
        </div>
  
        <div class="d-flex justify-content-center gap-3 mt-3">
          <button class="btn btn-success d-flex align-items-center" type="submit">
            <app-feather-icons [icon]="'check'" class="me-2"></app-feather-icons>
            <span class="text-center">Guardar</span>
          </button>
        </div>
      </form>
    </div>
  </div>




